import styled from 'styled-components'

export const Modal = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: ${({ $width }) => $width || 'auto'};
  height: ${({ $height }) => $height || '80%'};
  position: fixed;
  z-index: 999;
  visibility: ${({ $visible }) => $visible || 'hidden'};
  background: ${props => props.theme.colors.background.primary};
  border-radius: ${props => props.theme.radius.card};
  border: 1px solid ${props => props.theme.colors.border.medium};
  box-shadow: 0 2px 8px ${props => props.theme.colors.shadow.strong};
  overflow-y: auto;
  overflow-x: hidden;
  padding: 2rem;
  transition: all 0.3s ease;

  &::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${props => props.theme.colors.shadow.overlay};
    z-index: -1;
  }

  /* Scrollbar themed */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: ${props => props.theme.colors.scrollbar.track};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${props => props.theme.colors.scrollbar.thumb};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${props => props.theme.colors.scrollbar.thumbHover};
  }
`

export const ModalIcon = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;
  color: ${({ $color, theme }) => $color || theme.colors.text.tertiary};
  position: absolute;
  top: 1rem;
  right: 1rem;
  cursor: pointer;
  transition: ${props => props.theme.transitions.default};

  &:hover {
    color: ${props => props.theme.colors.text.primary};
  }
`

export const ModalTitle = styled.div`
  width: ${({ $width }) => $width || 'auto'};
  display: flex;
  flex-direction: ${({ $direction }) => $direction || 'column'};
  justify-content: ${({ $justify }) => $justify || 'center'};
  padding-left: ${({ $paddingleft }) => $paddingleft || '0'};
  padding-right: ${({ $paddingright }) => $paddingright || '0'};
  align-items: center;
  font-weight: 600;
  font-size: 1.25rem;
  font-family: ${props => props.theme.typography.fontFamily};
  color: ${props => props.theme.colors.text.primary};
  letter-spacing: -0.02em;
  transition: color 0.3s ease;
`

export const ModalContent = styled.div`
  width: ${({ $width }) => $width || '100%'};
  display: flex;
  flex-wrap: ${({ $wrap }) => $wrap || 'nowrap'};
  flex-direction: ${({ $direction }) => $direction || 'column'};
  justify-content: center;
  align-items: ${({ $align }) => $align || 'flex-start'};
  gap: 8px;
`

export const ModalLabel = styled.div`
  width: 100%;
  display: flex;
  justify-content: ${({ $position }) => $position || 'center'};
  align-items: center;
  gap: 0.5rem;
  font-size: ${props => props.theme.typography.fontSize.input};
  font-family: ${props => props.theme.typography.fontFamily};
  color: ${props => props.theme.colors.text.secondary};
  transition: color 0.3s ease;
`

export const ModalImageContainer = styled.div`
  display: flex;
  max-width: 650px;
  justify-content: center;
  align-items: center;
  align-content: center;
  gap: 20px;
`
